export interface UserProfile {
  /**
   * The user's UUID.
   */
  id: string;
  firstName?: string;
  lastName?: string;
  primaryEmail?: string;
  primaryPhone?: string;
  password?: string;
}
export interface UpdateUserInput {
  updateUserInput: {
    /**
     * The user's UUID.
     */
    guildUuid: string;
    firstName?: string;
    lastName?: string;
  };
}
export interface UpdateUserResponse {
  updateUser: {
    errors: string[];
  };
}

export type UpsertContactStrategyInput = {
  upsertContact: Omit<ContactStrategy, 'contactTypeName' | 'primary'> & {
    primary: boolean;
  };
};

export type ContactStrategyResponse = {
  ups_upsertContactStrategy: ContactStrategy;
};

export type ContactStrategy = {
  contactType: ContactType;
  contactTypeName: ContactTypeName;
  guildUuid: string;
  primary?: boolean;
  value: string;
};

export enum ContactType {
  PRIMARY_EMAIL,
  PRIMARY_PHONE,
}

export enum ContactTypeName {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
}
